import { Route, Routes } from "react-router-dom";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import HomePage from "../pages/Home";
import InvoicesPage from "../pages/Invoices";
import CreateInvoicePage from "../pages/Invoices/create";
import QuotesPage from "../pages/Quotes";
import CreateQuotePage from "../pages/Quotes/create";
import RecurringInvoicesPage from "../pages/RecurringInvoices";
import PaymentsPage from "../pages/Payments";
import CreateRecurringInvoicePage from "../pages/RecurringInvoices/create";
import CreatePaymentPage from "../pages/Payments/create";
import DeliveryNotesPage from "../pages/DeliveryNotes";
import CreateDeliveryNotePage from "../pages/DeliveryNotes/create";

export default function SalesRoutes() {
  return(
    <Routes>
      <Route path="home" element={<HomePage />} />

      <Route element={<PermissionRoute permission="sales.quotes.view" />}>
        <Route path="quotes">
          <Route path="" element={<QuotesPage />} />
          <Route path="create" element={<CreateQuotePage />} />
          <Route path="edit/:id" element={<CreateQuotePage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="sales.invoices.view" />}>
        <Route path="invoices">
          <Route path="" element={<InvoicesPage />} />
          <Route path="create" element={<CreateInvoicePage />} />
          <Route path="edit/:id" element={<CreateInvoicePage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="sales.delivery_notes.view" />}>
        <Route path="delivery-notes">
          <Route path="" element={<DeliveryNotesPage />} />
          <Route path="create" element={<CreateDeliveryNotePage />} />
          <Route path="edit/:id" element={<CreateDeliveryNotePage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="sales.recurring_invoices.view" />}>
        <Route path="recurring-invoices">
          <Route path="" element={<RecurringInvoicesPage />} />
          <Route path="create" element={<CreateRecurringInvoicePage />} />
          <Route path="edit/:id" element={<CreateRecurringInvoicePage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="sales.payments.view" />}>
        <Route path="payments">
          <Route path="" element={<PaymentsPage />} />
          <Route path="create" element={<CreatePaymentPage />} />
          <Route path="edit/:id" element={<CreatePaymentPage />} />
        </Route>
      </Route>
    </Routes>
  );
}